import React from 'react'
import routes from '../config/settings/routes'
import BrandLayout from '../components/Layouts/BrandLayout'
import ComparatorContainer from '../containers/Comparator/Comparator.container'
import CompareBuyersSectionContainer from '../containers/CompareBuyersSection/CompareBuyersSection.container'
import FooterContainer from '../containers/Footer/Footer.container'
import SearchBuyerPanelContainer from '../containers/SearchBuyerPanel/SearchBuyerPanel.container'
import TopNavbarContainer from '../containers/TopNavbar/TopNavbar.container'

/**
 * The Comparator's page.
 */
const Comparator = () => (
  <BrandLayout footer={<FooterContainer />}>
    <TopNavbarContainer menuActive={routes.comparator} />
    <SearchBuyerPanelContainer />
    <CompareBuyersSectionContainer />
    <ComparatorContainer />
  </BrandLayout>
)

export default Comparator
